import React, { Component } from 'react';
import './GridRow.scss'
import GridItem from '../GridElement/GridElement'
export default class gridRow extends Component {

    // Parse duration string "HH:MM:SS" to milliseconds
    parseDuration(duration) {
        if (!duration) return 0;
        const parts = duration.split(':');
        return ((parseInt(parts[0]) * 3600) + (parseInt(parts[1]) * 60) + parseFloat(parts[2])) * 1000;
    }

    // Check if two calls overlap in time
    isOverlapping(existingItem, newItem) {
        const existingStart = parseInt(existingItem.callStartMs);
        const existingEnd = existingStart + this.parseDuration(existingItem.duration);
        const newStart = parseInt(newItem.callStartMs);
        const newEnd = newStart + this.parseDuration(newItem.duration);

        // Overlapping if one starts before the other ends
        return existingStart < newEnd && newStart < existingEnd;
    }

    render() {
        let list = [];
        return (

            <div className="grid-row-inner">
                {
                    this.props.rowContent.map((item, i) => {
                        if (item.scenarioId != null && item.scenarioId !== "") { // skip for empty Scenario, e.g. Chat messages
                            let unique_id = item.scenarioId + item.userId;
                            const matchingEntries = list.filter(entry => entry.id === unique_id);
                            if (matchingEntries.length > 0) {
                                // Same scenarioId+userId found, check if any of them overlap
                                if (matchingEntries.some(entry => this.isOverlapping(entry.item, item))) {
                                    item.isDuplicate = true;
                                }
                            }
                            list.push({ id: unique_id, item: item });
                        }
                        return (<GridItem
                            key={i}
                            apol={this.props.apol}
                            item={item}
                            authorization={this.props.authorization}
                            userRules={this.props.userRules}
                            onlyOne={this.props.onlyOne}
                            theme={this.props.theme}
                            toDoArea={this.props.toDoArea}
                        />
                        );
                    })
                }
            </div>

        );
    };
}